<template>
	<div class="session-wrapper">
        <div class="session-left">
            <div class="bg">
                <img src="/static/img/graphic1.svg">
            </div>
        </div>
        <div class="session-right text-xs-center">
            <div class="session-table-cell">
                <div class="div-icon mb-3 pointer" @click="goHome">
                    <img src="/static/img/logo.jpg" width="78" height="78"/>
                </div>
            </div>
            <div class="mt-5 mb-3">
                <div class="font-lg mb-5">{{$t("activation.valid")}}</div>
                <div>
                    <v-btn round flat outline large color="aquamarine" @click="goHome"><b>{{$t("page404.homepageButton")}}</b></v-btn>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../config.js'
    export default {
        data(){
            return{
                
            }
        },
        created(){
            
        },
        mounted(){
            
        },
        watch:{
            
        },
        methods: {
            goHome(){
                this.$router.push({name: "home"});
            },
        },
    }
</script>


// WEBPACK FOOTER //
// LinkInvalid.vue?50425eb2